import { useIntl } from "react-intl";

interface ReservationNextStepsProps {
  type: "flight" | "hotel";
}

export const ReservationNextSteps = ({ type }: ReservationNextStepsProps) => {
  const intl = useIntl();
  const showFlightInfo = type === "flight";
  const showHotelInfo = type === "hotel";

  return (
    <section className="mt-4">
      <h3 className="section-title">
        {intl.formatMessage({
          defaultMessage: "What's next?",
          description:
            "Section heading for post-booking next steps and instructions",
        })}
      </h3>
      <div className="section-card flex flex-col gap-2 text-sm">
        {showFlightInfo ? (
          <p>
            {intl.formatMessage({
              defaultMessage:
                "If you would like to pre-select your seat, please enter your ticket number and last name on the airline's website to reserve your seat two hours before takeoff.",
              description:
                "Post-booking instructions for flights: how to use the ticket number for online check-in",
            })}
          </p>
        ) : null}
        {showHotelInfo ? (
          <p>
            {intl.formatMessage({
              defaultMessage:
                "Provide hotel personnel with reservation number while checking in.",
              description:
                "Post-booking instructions for hotels: present reservation number at hotel check-in",
            })}
          </p>
        ) : null}
      </div>
    </section>
  );
};
